import BaseDatePicker from '@Components/Form/BaseDatePicker/BaseDatePicker'
import BaseSelect from '@Components/Form/BaseSelect/BaseSelect'
import { RedditTextField } from '@Components/Form/RedditTextField/RedditTextField'
import { EClassifications } from '@Enum/classifications.enum'
import { MClassification } from '@Models/classification.model'
import { ICommonQuery, ISelectOptions } from '@Models/common.model'
import { FormHelperText, Grid, TextareaAutosize } from '@mui/material'
import { APIServices } from '@Services/api.service'
import { FormService } from '@Services/form.service'
import ClassificationAction from '@Stores/client/actions/classification.action'
import { useEffect } from 'react'
import { Controller } from 'react-hook-form'
import { connect } from 'react-redux'
import * as Redux from 'redux'

interface IAnomalyForm {
    control: any
    errors: any

    // redux
    getIssues?: (params?: ICommonQuery) => void
    issues?: MClassification[]
}

const AnomalyForm = (props: IAnomalyForm) => {
    // core section
    const { control, errors, getIssues, issues } = props

    useEffect(() => {
        if (getIssues) getIssues()
        return () => {
            APIServices.axiosCancelToken()
        }
    }, [])

    // main
    return (
        // elements section
        <Grid container spacing={0}>
            <Grid item sm={8} xs={12} container spacing={1}>
                <Grid item sm={6}>
                    <Controller
                        control={control}
                        name="madeAt"
                        defaultValue={null}
                        rules={{ required: true }}
                        render={({ field: { ref, value, onChange } }: any) => (
                            <BaseDatePicker
                                inputRef={ref}
                                label="Date"
                                onChange={onChange}
                                value={value}
                                fullWidth
                                error={errors?.madeAt && true}
                                helperText={FormService.getErrorMessage(
                                    errors,
                                    'madeAt',
                                    'Date'
                                )}
                                disabled
                            />
                        )}
                    />
                </Grid>
                <Grid item sm={6}>
                    <Controller
                        control={control}
                        name="issue"
                        defaultValue=""
                        rules={{ required: true }}
                        render={({
                            field: { ref, value, onChange, ...field },
                        }: any) => (
                            <BaseSelect
                                {...field}
                                inputRef={ref}
                                value={value}
                                onChange={onChange}
                                options={issues}
                                label="Issue"
                                fullWidth
                                error={errors?.issue && true}
                                helperText={FormService.getErrorMessage(
                                    errors,
                                    'issue',
                                    'Issue'
                                )}
                            />
                        )}
                    />
                </Grid>
                <Grid item sm={6}>
                    <Controller
                        control={control}
                        name="ref"
                        defaultValue=""
                        rules={{ required: true }}
                        render={({
                            field: { ref, value, onChange, ...field },
                        }: any) => (
                            <RedditTextField
                                {...field}
                                value={value}
                                onChange={onChange}
                                inputRef={ref}
                                label="Ref #"
                                variant="filled"
                                fullWidth
                                error={errors?.ref && true}
                                helperText={FormService.getErrorMessage(
                                    errors,
                                    'ref',
                                    'Ref #'
                                )}
                                disabled
                            />
                        )}
                    />
                </Grid>
                <Grid item sm={12}>
                    <Controller
                        control={control}
                        name="anomaly"
                        defaultValue=""
                        rules={{ required: true }}
                        render={({
                            field: { ref, value, onChange, ...field },
                        }: any) => (
                            <span>
                                <TextareaAutosize
                                    ref={ref}
                                    value={value}
                                    onChange={onChange}
                                    className="text-area"
                                    placeholder="Anomaly"
                                />
                                {errors?.anomaly && true && (
                                    <FormHelperText error className="ml-3">
                                        {FormService.getErrorMessage(
                                            errors,
                                            'anomaly',
                                            'Anomaly'
                                        )}
                                    </FormHelperText>
                                )}
                            </span>
                        )}
                    />
                </Grid>
            </Grid>
        </Grid>
    )
}

// store section
const mapStateToProps = (store: any) => {
    const { issues } = store?.client?.classifications
    return { issues }
}

const mapDispatchToProps = (dispatch: Redux.Dispatch) => {
    const { getClassifications } = ClassificationAction
    return {
        getIssues: (params?: ICommonQuery) =>
            dispatch(getClassifications(EClassifications.ISSUE, params) as any),
    }
}

export default connect(mapStateToProps, mapDispatchToProps)(AnomalyForm)
